module.exports = __webpack_public_path__ + "static/media/cashM.0dd706c9.svg";